export default __webpack_public_path__ + "static/media/include_11@2x.b0b87ce5.jpg";